export default "__VITE_ASSET__Bv3ME0PP__"